import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/mutations/deleteSegment.mutation';

export const deleteSegment = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deleteSegment${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
